import { render, staticRenderFns } from "./ChangableMapComponent.vue?vue&type=template&id=64be6afc&scoped=true"
import script from "./ChangableMapComponent.vue?vue&type=script&lang=js"
export * from "./ChangableMapComponent.vue?vue&type=script&lang=js"
import style0 from "./ChangableMapComponent.vue?vue&type=style&index=0&id=64be6afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be6afc",
  null
  
)

export default component.exports